import {SimplePage} from "../../elements/Pages";
import React from "react";
import {useQuery} from "@tanstack/react-query";
import {getStudierzeitRooms} from "../../../api/organizational";
import ListViewTable, {TableLink} from "../../elements/tables/ListViewTable";
import {Link} from "react-router-dom";

export default function StudierzeitLogRooms() {

    const {isLoading, isSuccess, data} = useQuery([
        "studierzeit_rooms"],
        getStudierzeitRooms,
        {refetchInterval: 1000 * 60 * 60 * 24}
    );

    const columns = [
        {
            accessorKey: "name",
            id: "name",
            header: "Studierzimmer",
            enableColumnFilter: false,
        },
        {
            accessorKey: "id",
            id: "log",
            header: "Dienstbuch",
            cell: info => (
                <TableLink label="Einträge" to={`/studierzeit/rooms/${info.getValue()}/log`} />
            ),
            enableColumnFilter: false,
            disableRowLink: true,
        },
        {
            accessorKey: "id",
            id: "new",
            header: "Neuer Eintrag",
            cell: info => (
                <TableLink label="Neuer Eintrag" to={`/studierzeit/rooms/${info.getValue()}/log/new`} />
            ),
            enableColumnFilter: false,
            disableRowLink: true,
        }
    ];

    function getRowLink(row) {
        return `/studierzeit/rooms/${row.original.id}/log`;
    }

    return (
        <SimplePage>
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                            Dienstbuch nach Studierzimmer
                        </h3>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <Link to={`/studierzeit/log/new`}>
                            <button
                                type="button"
                                className="inline-flex items-center justify-center rounded-md border border-transparent bg-imsblue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-imsblue-700 focus:outline-none focus:ring-2 focus:ring-imsblue-500 focus:ring-offset-2 sm:w-auto"
                            >
                                Neuer Eintrag
                            </button>
                        </Link>
                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            {isSuccess && data && (
                                <ListViewTable
                                    data={data}
                                    columns={columns}
                                    isLoading={isLoading}
                                    disableGlobalSearch={false}
                                    getRowLink={getRowLink}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SimplePage>
    );
}
